import { Component, inject, signal } from '@angular/core';
import { AuthService } from '../../../core/services/auth.service';
import { environment } from '../../../../environments/environment';
import { RecordTableApiService } from "../../../core/services-api/record-table-api.service";
import { developmentItems } from "./configs/development-page-config";
import { DevelopmentPageLineParams, ReportStatus } from "./types/development-page.types";
import { ErrorService } from "../../../core/services/error.service";
import { DevelopmentPageLineComponent } from "./components/development-page-line/development-page-line.component";
import { MatButton } from "@angular/material/button";
import { MatProgressSpinner } from "@angular/material/progress-spinner";

@Component({
  selector: 'app-development-page',
  standalone: true,
  imports: [
    DevelopmentPageLineComponent,
    MatButton,
    MatProgressSpinner
  ],
  templateUrl: './development-page.component.html',
  styleUrl: './development-page.component.scss'
})
export class DevelopmentPageComponent {
  private authService: AuthService = inject(AuthService);
  private recordTableApiService: RecordTableApiService = inject(RecordTableApiService);
  private errorService: ErrorService = inject(ErrorService);

  public readonly developmentItems = developmentItems;

  public isGenerate = signal<boolean>(false);
  public reportStatus = signal<ReportStatus>(null);

  public getHref(developmentPageLine: DevelopmentPageLineParams): string {
    const map = new Map<string, () => string>([
      ['Swagger:', () => `${environment.hostname}:${environment.port}/api/swagger-ui/index.html#/`],
      ['Roles:', () => this.authService.getUserRoles().join(', ')],
      ['Access token:', () => this.authService.getJwtTokens().access],
      ['Refresh token:', () => this.authService.getJwtTokens().refresh],
    ]);

    return map.get(developmentPageLine.title)?.() ?? developmentPageLine.href ?? '';
  }

  public generateReports(path: string): void {
    this.isGenerate.set(true);
    this.reportStatus.set('loading');
    this.recordTableApiService.generateReports(path)
      .subscribe({
        next: () => {
          this.reportStatus.set('success');
          this.isGenerate.set(false);
        },
        error: (error) => {
          this.reportStatus.set('error');
          this.isGenerate.set(false);
          this.errorService.showErrorMessage(`Ошибка при генерации отчетов: ${error}`);
        }
      });
  }
}
